import React from "react";
import { Page } from "@shopify/polaris";

const AppPageFrame = ({ title, children, maxWidth = "1400px", gap = "20px" }) => {
  return (
    <Page fullWidth title={title}>
      <div
        style={{
          width: "100%",
          maxWidth,
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap,
          paddingBottom: "24px",
        }}
      >
        {children}
      </div>
    </Page>
  );
};

export default AppPageFrame;
